import React, { Fragment } from "react";
import GenericApp from "../GenericApp";
import SmsHistoryAppForm from "./SmsHistoryAppForm";
import { useDispatch, useSelector } from "react-redux";
import GenericAppUtils from "../GenericApp/GenericAppUtils";
import { useHistory } from "react-router-dom";
import IntlMessages from "../../../@jumbo/utils/IntlMessages";
import { useIntl } from "react-intl";
import AttachFileIcon from "@material-ui/icons/Attachment";
import { SMS_HISTORY_DESTROY, SMS_HISTORY_STORE, SMS_HISTORY_UPDATE } from "../../../redux/action-types/SmsHistoryActionTypes";
import { formatDateTime } from "@vinsystems/js-library/FormatUtils";

export const SMS_HISTORY_FRONTEND_INDEX_URL = '/apps/sms-history';
export const SMS_HISTORY_PAGINATE_URL = '/SmsHistory/Paginate';
const NAME = 'sms-history-app';
const TITLE = 'Sms History';
const SUBTITLE = 'App';
const ICON = <AttachFileIcon />;

function TenantApp(props) {

  const dispatch = useDispatch();
  const hist = useHistory();
  let { page, pageLimit } = useSelector(({ genericAppReducer }) => genericAppReducer);
  const intl = useIntl();

  const handleIndex = () => {
    hist.push(SMS_HISTORY_FRONTEND_INDEX_URL);
  }

  const handleDestroy = (values) => {
    dispatch({type: SMS_HISTORY_DESTROY, payload: values});
  };

  const handleSubmit = (values, formik) => {
    const type = values.id ?  SMS_HISTORY_UPDATE : SMS_HISTORY_STORE;
    dispatch({type: type, payload: values});
  };

  const AppSettings = {
    name: `${NAME}-app`,
    title: <IntlMessages id={TITLE} />,
    subTitle: SUBTITLE,
    searchTitle: intl.formatMessage({ id: 'Search...' }),
    notFoundTitle: <IntlMessages id={'No records found'} />,
    isCreate: false,
    isRead: true,
    isUpdate: true,
    isDelete: false,
    urls: {
      indexFrontend: SMS_HISTORY_FRONTEND_INDEX_URL
    },
    createButton: {
      title: <IntlMessages id={'Create New'} />,
      icon: null
    },
    headers: [
      <IntlMessages id={'Name'} />,
      <IntlMessages id={'Created'} />,
      <IntlMessages id={'Id'} />

    ],
    menuList: [
      {
        title: "Menu",
        items: [
          { id: 1, name: <IntlMessages id={TITLE} />, slug: `${NAME}-all`, icon: ICON, onClick: handleIndex }
        ]
      }
    ],
    recordMenuList: [
      {
        title: "Record Menu",
        items: [
          // { id: 1, name: "Users", slug: "users", icon: <GroupIcon />, onClick: (e) => console.log(e) }
        ]
      }
    ],
    dispatchActions: {
      paginate: GenericAppUtils.GetPaginateFunc(SMS_HISTORY_PAGINATE_URL),
    },
    events: {
      onRenderTitle: (item) => (item.userName),
      onRenderSubTitle: (item) => (item.userId),
      onRenderAvatar: (item) => (null), //(item) => (FileUploaderActions.getDownloadImageUrl(item.slug, false)),
      onRenderExtraCells: (item) => ([formatDateTime(item.createdDate), item.id]),
      onEditClick : (item) => console.log(item),
      onShowClick : (item) => console.log(item),
      onDeleteClick : handleDestroy,
      onDeleteMultiple : (items) => console.log(items),
      onCreateClick : (e) => console.log(e),
      onStarClick: null, //(item, status) => console.log(item, status),
      onSearchChange: null,//(s) => console.log(s),
      onSearchEnterKeyDown: null, //if this property is null, it will call the default search endpoint
    }
  };
  return (
    <Fragment>
      <GenericApp appSettings={AppSettings} form={<SmsHistoryAppForm onSubmit={handleSubmit}/>} isUseDialog={false} />
    </Fragment>
  );

}

export default TenantApp;
